const init = () => {
  const accordionPreviews = document.querySelectorAll('[data-accordion-preview]')

  accordionPreviews.forEach(accordion => {
    const button = accordion.querySelector('button')
    const content = accordion.querySelector(
      '[data-accordion-preview-content="accordion-preview-content"]',
    )

    button.addEventListener('click', () => {
      const accordionOpen = button.dataset.accordionPreviewOpen === 'true'
      button.setAttribute('data-accordion-preview-open', !accordionOpen)

      if (accordionOpen) {
        content.setAttribute(
          'class',
          content
            .getAttribute('class')
            ?.replace('ev-accordion-preview-visible', 'ev-accordion-preview-hidden'),
        )
        button.innerHTML = button.innerHTML.replace('See less', 'Read more')
        button.lastChild.style.transform = 'rotate(0)'
      } else {
        content.setAttribute(
          'class',
          content
            .getAttribute('class')
            ?.replace('ev-accordion-preview-hidden', 'ev-accordion-preview-visible'),
        )
        button.innerHTML = button.innerHTML.replace('Read more', 'See less')
        button.lastChild.style.transform = 'rotate(180deg)'
      }
    })
  })
}

export default init
